import { render } from "./dimension.vue?vue&type=template&id=76d6d030"
import script from "./dimension.vue?vue&type=script&lang=js"
export * from "./dimension.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__